/* eslint-disable camelcase */
import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getSecondarySalesPersonAPI } from "@tKgpco/Services/RfqQuoteSecondarySalesPersonService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type Parameters = {
    id: string;
} & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters>;

export const PopulateApiParameters: HandlerType = props => {
    const { id } = props.parameter;
    props.apiParameter = {
        id
    };
};

export const SecondarySalesPerson: HandlerType = async props => {
    try {
        const apiResult = await getSecondarySalesPersonAPI(props.apiParameter.id);
        if(apiResult) {
            props.parameter.onSuccess?.(apiResult);
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const chain = [PopulateApiParameters, SecondarySalesPerson];

const getSecondarySalesPerson = createHandlerChainRunner(chain, "GetSecondarySalesPerson");
export default getSecondarySalesPerson;